// eslint-disable-next-line import/prefer-default-export
export const Constants = {
  // API_URL: 'https://ciligoapidev.juloa.com/api',
  // ROOT_URL: 'https://ciligoapidev.juloa.com',
  API_URL: process.env.REACT_APP_API_URL ?? "http://localhost:1337/api",
  ROOT_URL: process.env.REACT_APP_ROOT_URL ?? "http://localhost:1337",
};
